function pdpAccordion() {
  const accordionItems = document.querySelectorAll('.pdp-accordion-item');
  for (let i = 0; i < accordionItems.length; i++) {
    const item = accordionItems[i];
    const h3 = getChild(item, 'h3');
    h3.addEventListener('click', function (e) {
      const wrapper = getParent(e.target, 'pdp-accordion');
      const thisActives = getChild(wrapper, '.active', 1);

      const clickedParent = getParent(e.target, 'pdp-accordion-item');
      const content = getChild(clickedParent, '.pdp-accordion-content');
      if (classHelper(content, 'c', 'active')) {
        classHelper(content, 'r', 'active')
        classHelper(clickedParent, 'r', 'active')
        clickedParent.removeAttribute('aria-expanded')
        return;
      }

      classHelper(thisActives, 'r', 'active');
      classHelper(content, 'a', 'active');
      classHelper(clickedParent, 'a', 'active');
      clickedParent.setAttribute('aria-expanded', 'true')
    });
  }
}

function pdpInit() {
  pdpAccordion();
}

document.readyState !== 'loading' ? pdpInit() : document.addEventListener('DOMContentLoaded', pdpInit);
